import { Suspense } from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import { OpsPermissions } from '~/lib/constants/permissions.constants';
import { useGlobalContext } from '~/lib/contexts/GlobalContext';
import useHasAuth0Permission from '~/lib/hooks/useHasAuth0Permission';
import PageNotFoundPage from '~/pages/404';
import UserProfile from '~/pages/admin/ProviderProfile';
import Loading from '~/pages/loading';
import ScriptSureSyncDashboardPage from '~/pages/ops/ScriptSureSyncDashboard';
import { Path } from '~/routes/constants';

const SuspenseWrapper = (Component: React.ComponentType) => (
  <Suspense fallback={<Loading />}>
    <Component />
  </Suspense>
);

const OpsRoutes = () => {
  const { currentUser } = useGlobalContext();
  const hasScriptSureSyncDashboard = useHasAuth0Permission(
    OpsPermissions.OPS_SCRIPTSURE_SYNC_DASHBOARD,
  );
  const homePath = hasScriptSureSyncDashboard
    ? Path.OPS_SCRIPTSURE_SYNC_DASHBOARD
    : `${Path.OPS_VIEW_PROFILE}/${currentUser?.userId}/info`;

  return (
    <Switch>
      <Route
        exact
        path={[Path.HOME, Path.LOGIN, Path.PORTAL, Path.OPS]}
        render={() => <Redirect to={homePath} />}
      />
      {hasScriptSureSyncDashboard && (
        <Route
          exact
          path={Path.OPS_SCRIPTSURE_SYNC_DASHBOARD}
          render={() => SuspenseWrapper(ScriptSureSyncDashboardPage)}
        />
      )}
      <Route
        exact
        path={`${Path.OPS_VIEW_PROFILE}/:id/:subPath(info|calendar)`}
        render={() => SuspenseWrapper(UserProfile)}
      />
      <Route render={() => SuspenseWrapper(PageNotFoundPage)} />
    </Switch>
  );
};

export default OpsRoutes;
